<template>
  <div class="company-department-bd ub">
    <div class="aside">
      <div class="title">
        <i class="icon icon-zuzhi"></i>
        <span>{{ $t('Common.com_department') }}</span>
      </div>
      <div class="search ub">
        <div class="ub-f1">
          <search-input width="100%" :placeholder="$t('Common.com_department_name')" v-model="appKey"></search-input>
        </div>
        <!-- <el-button style="padding: 0 13px !important; margin-left: 16px" type="warning" circle icon="icon icon-tianjia"></el-button> -->
      </div>
      <div class="tree">
        <custom-tree
          :data="organTree"
          node-key="bizId"
          default-expand-all
          :listener="appKey"
          :filterKeys="['bizName']"
          :props="{ label: 'bizName' }"
          v-model="organData"
          :action="treeAction"
          @add="addDepartment"
          @edit="editDepartment"
          @delete="deleteDepartment"
          @handleNode="handleNodeClick"
        >
          <template slot="label" slot-scope="scope">{{ scope.node.label }}({{ scope.data.bizUserCont }})</template>
        </custom-tree>
      </div>
    </div>
    <div style="width: 1px; background: #f0f0f0"></div>
    <div class="section ub-f1 ubv">
      <div class="tip">
        {{ organData.bizName }}
      </div>
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item v-if="funcView.department_add_user">
            <el-button type="warning" @click="bindUsers" :disabled="!organData.bizId || organData.bizType == 1">
              <i class="icon icon-guanlian"></i>
              <span>&ensp;{{ $t('company_department.tian_jia_yuan_gong') }}</span>
            </el-button>
          </el-form-item>
          <el-form-item v-if="funcView.department_del_user">
            <el-button @click="unbindUsers" :disabled="!organData.bizId || !tableSelect.length || organData.bizType == 1">
              <i class="icon icon-quxiaoguanlian"></i>
              <span>&ensp;{{ $t('company_department.yi_chu_yuan_gong') }}</span>
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input width="280px" v-model="formSearch.search" :placeholder="$t('company_department.ygxmdlzhlxdhyx')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd ub-f1">
        <custom-table stripe type="checkbox" tableCode="portal_user_table" v-model="tableSelect" :data="organUserList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
          <el-table-column fixed="right">
            <template slot-scope="scope" v-if="funcView.department_del_user">
              <el-button :disabled="!organData.bizId || organData.bizType == 1" @click="unbindUser(scope.row)" type="text" size="mini">{{ $t('company_department.yi_chu_yuan_gong') }}</el-button>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <department-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getOrganTree"></department-item-dialog>
    <department-user-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="successBindUsers"></department-user-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTree from '@/components/customTree.vue';
import departmentItemDialog from './children/department_item_dialog.vue';
import departmentUserDialog from './children/department_user_dialog.vue';

// i18n-lang-component
export default {
  name: 'department',
  components: { customTree, departmentItemDialog, departmentUserDialog },
  data() {
    return {
      tableSelect: [],
      appKey: '',
      organTree: [],
      organData: {},
      dialogVisible: false,
      dialogModel: {},
      // dialogData: {},

      dialogVisible1: false,
      dialogModel1: {},

      organUserList: [],
      totalRows: 0,
      childrenCount: 0,
      totalCount: 0,
      isLoading: false,

      formSearch: {
        search: '',
        bizId: '',
        bizType: '',
        pageSize: 50,
        pageNum: 1,
        isAssociated: 1,
      },
    };
  },
  computed: {
    treeAction() {
      return this.organData.bizType === 2
        ? {
          add: this.funcView.department_add,
          edit: this.funcView.department_edit,
          delete: this.funcView.department_del,
        }
        : {
          add: this.funcView.department_add,
        };
    },
  },
  mounted() {
    this.reserFormSearch = JSON.stringify(this.formSearch);
    this.getOrganTree();
    this.getFuncView();
  },
  methods: {
    // 选中部门
    handleNodeClick: function () {
      this.formSearch = JSON.parse(this.reserFormSearch);
      this.getOrganUserPage();
      this.getDepartmentCount();
    },
    // 获取部门树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isCountUser: 1 }).then((res) => {
        this.organTree = [res.data];
      });
    },
    // 新增部门
    addDepartment: function (data) {
      this.dialogModel = {
        type: 'add',
        title: this.$t('company_department.xin_zeng_bu_men'),
        bizId: data.bizId,
        bizName: data.bizName,
      };
      this.dialogVisible = true;
    },
    // 编辑部门
    editDepartment: function (data) {
      this.dialogModel = {
        type: 'edit',
        title: this.$t('company_department.bian_ji_bu_men'),
        bizId: data.bizId,
        bizName: data.bizName,
      };
      this.dialogVisible = true;
    },
    // 删除部门
    deleteDepartment: function (data) {
      this.$showConfirm(this, this.$t('company_department.nqdyscxzdbmm'))
        .then(() => {
          this.$postJSON(`${apis.DepartmentDelete}/${data.departmentId}`).then(() => {
            this.getOrganTree();
          });
        })
        .catch(() => {});
    },
    // 关联用户弹窗
    bindUsers: function () {
      this.dialogModel1 = {
        title: this.$t('company_department.tjygdbm'),
        data: this.organData,
      };
      this.dialogVisible1 = true;
    },
    // 关联用户成功
    successBindUsers: function () {
      this.getOrganTree();
      this.getOrganUserPage();
    },
    // 取消关联部门
    unbindUser: function (data) {
      this.$showConfirm(this, this.$t('company_department.nqdyjxzdygyccbmm'))
        .then(() => {
          this.$postJSON(apis.DepartmentUserUnbind, {
            departmentId: this.organData.bizId,
            userIds: [data.userId],
          }).then(() => {
            this.getOrganTree();
            this.getOrganUserPage();
          });
        })
        .catch(() => {});
    },
    // 取消关联部门(批量)
    unbindUsers: function () {
      this.$showConfirm(this, this.$t('company_department.nqdyjxzdygyccbmm'))
        .then(() => {
          const params = this.tableSelect.map(t => t.userId);
          this.$postJSON(apis.DepartmentUserUnbind, {
            departmentId: this.organData.bizId,
            userIds: params,
          }).then(() => {
            this.getOrganTree();
            this.getOrganUserPage();
          });
        })
        .catch(() => {});
    },
    // 获取部门用户列表
    getOrganUserPage: function () {
      this.formSearch.bizId = this.organData.bizId;
      this.formSearch.bizType = this.organData.bizType;
      this.isLoading = true;
      this.$getJSON(apis.DepartmentUserPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.organUserList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取部门统计数
    getDepartmentCount: function () {
      this.$getJSON(apis.DepartmentCount, {
        bizId: this.organData.bizId,
        bizType: this.organData.bizType,
      }).then((res) => {
        this.childrenCount = res.data.childrenCount;
        this.totalCount = res.data.totalCount;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganUserPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.company-department-bd {
  background-color: #ffffff;
  border-radius: 16px;
  min-height: 850px;
  .aside {
    width: 486px;
    padding: 24px;
    .title {
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: $--color-text-regular;
    }
    .search {
      margin: 24px 0;
    }
  }
  .section {
    padding: 24px 24px 0;
  }

  .tip {
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    color: $--color-primary;
    margin-bottom: 24px;
  }
}
</style>
